export default __webpack_public_path__ + "static/media/heliport.62e084e0.svg";